// src/components/common/RoleRoute.tsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface RoleRouteProps {
    children: React.ReactNode;
    allowedRoles: string[];
}

/**
 * Проверяет, есть ли у пользователя одна из разрешённых ролей.
 * Если нет — редиректит на /404.
 */
const RoleRoute: React.FC<RoleRouteProps> = ({ children, allowedRoles }) => {
    const { user } = useAuth();

    if (!user || !user.roles) {
        return <Navigate to="/404" replace />;
    }

    const hasAccess = user.roles.some(role => allowedRoles.includes(role));

    if (!hasAccess) {
        return <Navigate to="/404" replace />;
    }

    return <>{children}</>;
};

export default RoleRoute;